export const STATUS_CODES = {
	ERROR: 100,
	PASSWORD: 104,
	DELETED: 105,
	NO_USER: 106,
	OTHER: 107,
	DISABLED: 108,
	NEEDS_2FA: 147,
	BAD_2FA: 148,
	PROVISIONAL: 149,
	BLACKLISTED: 150,
	NEED_CAPTCHA: 151,
	NEED_SMS_2FA: 152,
};

export const DIRECT_LINKABLE_SCREENS = {
	PASSWORD_RESET: "reset_password",
};

export const SCREENS = {
	LOGIN: "LOGIN",
	PASSWORD_RESET: "PASSWORD_RESET",
	PASSWORD_SUBMIT: "PASSWORD_SUBMIT",
	REACTIVATE: "REACTIVATE",
	TWO_FACTOR: "TWO_FACTOR",
	CAPTCHA: "CAPTCHA",
};
export const SCREEN_SPEED = 400;

export default {
	STATUS_CODES,
	SCREENS,
	SCREEN_SPEED,
};



// WEBPACK FOOTER //
// ./src/apps/login_old/util/constants.js